<template>
  <div>
    <loading v-if="showLoading"></loading>
    <Breadcrumb v-bind:data="BreadcrumbList"></Breadcrumb>
    <account-status :account_status="account_status"></account-status>
    <div class="widget has-shadow">

      <div class="widget-header bordered  d-flex align-items-center">
        <h2>مدیریت پرداخت ها</h2>
      </div>
      <div class="widget-body">
        <div v-if="account_status=='active'">
          <div class="search_form order_search">
            <pdatepicker
              v-model="date"
              placeholder="تاریخ پرداخت"
              input-class="form-control"
              hover-day-back-color="#00bfd6"
              header-background-color="#00bfd6"
              chosen-day-back-color="#00bfd6"
            ></pdatepicker>

            <button class="btn btn-primary" v-on:click="getList(1)" style="margin-right:10px" >جست و جو</button>
          </div>

          <table class="table table-bordered">
            <thead>
              <tr>
                <th>ردیف</th>
                <th>شناسه پرداخت</th>
                <th>مبلغ پرداخت شده</th>
                <th>زمان ثبت</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row,key) in list.data" :key="key">
                <td>{{ getRow(key) }}</td>
                <td>{{ replaceNumber(row.shenase) }}</td>
                <td>{{ replaceNumber(number_format(row.price)) }} ریال</td>
                <td>{{ getDate(row.time,true) }}</td>
              </tr>
              <tr v-if="list.data.length==0">
                <td colspan="4">رکوردی یافت نشد</td>
              </tr>
            </tbody>
          </table>

          <pagination :data="list" @pagination-change-page="getList"></pagination>
        </div>
        <div v-else>
          <p style="padding-top:100px;text-align:center;font-size:50px">
            <span class="fa fa-exclamation"></span>
          </p>
          <p
            style="text-align:center;padding-bottom:80px"
          >شما دسترسی لازم برای عملیات جاری را ندارید</p>
        </div>
      </div>
    </div>
    <server-error-message v-if="server_error"></server-error-message>
  </div>
</template>

<script>
import myMinix from "../myMixin";
export default {
  mixins: [myMinix],
  data() {
    return {
      showLoading: false,
      server_error: false,
      account_status: "active",
      BreadcrumbList: [{ path: "/orders/payments", title: "مدیریت پرداخت ها" },],
      date: "",
      list: { data: [] },
      page: 1,
      monthName:[
        'فروردین',
        'اردیبهشت',
        'خرداد',
        'تیر',
        'مرداد',
        'شهریور',
        'مهر',
        'آبان',
        'آذر',
        'دی',
        'بهمن',
        'اسفند'
      ]
    };
  },
  mounted() {
    this.account_status = localStorage.getItem("account_status");
    this.$emit("setSideBarItem", "report");
    this.getList(1);
  },
  methods: {
    getList: function(page = 1) {
      this.page = 1;
      this.showLoading = true;
      const url =this.$siteUrl + "/api/seller/payemnt?page=" +page +'&date='+this.date;
      this.axios
        .get(url, this.setHeader())
        .then(response => {
          this.showLoading = false;
          const result = this.setAccountStatus(response.data);
          if (result) {
            this.list = response.data;
          }
        })
        .catch(error => {
          this.setCatch(error);
        });
    }
  }
};
</script>

<style>
</style>